import { useState } from "react";
import { Grid, Box } from "@mui/material";
import HelpSidebar from "./HelpSidebar";
import { RELEASE_STAGE } from "app/utils/constants/releaseStages";
import { useSelector } from "react-redux";
import Sb08FAQ from "./faq/SB-08";
import OAShellFAQ from "./faq/OA";
import ReferenceDownloadFAQ from "./faq/ReferenceDownloader";
import AppGenFAQ from "./faq/AppGen";
import ComingSoon from "../../../../components/ComingSoon";
import RemoveEmbeddedFonts from "./faq/RemoveEmbeddedFonts";
import {USPatent, USTrademark, AUPatent, AUTrademark} from "./faq/BibData";
import GettingStarted from "./faq/GettingStarted";
import TechnicalSupport from "./faq/TechnicalSupport";
import Downloader1449And892 from "./faq/Downloader1449And892";
import DownloaderOathADS from "./faq/DownloaderOathADS";
import ReferenceCount from "./faq/ReferenceCount";
import CFR37 from "./faq/CFR37";
import RefExtractor from "./faq/RefExtractor";
import PatentFileWrapperDownloader from "./faq/PatentFileWrapperDownloader";
import GPOA from "./faq/GPOA";
import PatentCorrespondenceAddress from "./faq/PatentCorrespondenceAddress";
import ApplicationCorrespondenceAddress from "./faq/ApplicationCorrespondenceAddress";
import TransmittalRCE from "./faq/TransmittalRCE";
import TransmittalRCE_EFS from "./faq/TransmittalRCE_EFS";
import ClaimsFormatter from "./faq/ClaimsFormatter";
import EPPatent from "./faq/EPPatent";
import USTrademarkImageDownload from "./faq/USTrademarkImageDownload";
import GlobalPatent from "./faq/GlobalPatent";

const FAQs = () => {
  const [tab, setTab] = useState("Getting Started");
  const { intentList } = useSelector((state) => ({ ...state }));

  let generalItems = [
    { label: "Getting Started", subMenus: [], subKey: "" },
    { label: "Support & Help", subMenus: [], subKey: "" },
  ];

  const sidebarItems = (intentListParam) => {
    const dynamicItems = [];
    dynamicItems.push(generalItems[0]);

    if (intentListParam && Object.keys(intentListParam).length > 0) {
      Object.entries(intentListParam).forEach(([parentKey, children]) => {
        const normalizedChildren = Array.isArray(children) ? children : [children];
        // A task with a single subtask is flattened into a top-level entry, so the
        // release stage has to be carried up from that lone child alongside its label.
        const isFlattened = normalizedChildren.length === 1;
        dynamicItems.push({
          label: isFlattened ? normalizedChildren[0].description : parentKey,
          releaseStage: isFlattened ? normalizedChildren[0].releaseStage : RELEASE_STAGE.STABLE,
          subMenus: normalizedChildren.map((child) => ({
            label: child.description,
            releaseStage: child.releaseStage,
          })),
          subKey: "",
        });
      });
    }
    dynamicItems.push(generalItems[1]);
    return dynamicItems;
  };

  const renderFaqDoc = (intent) => {
    switch (intent) {
      case "SB-08 Generator":
        return <Sb08FAQ />;
      case "OA Shell Draft":
        return <OAShellFAQ />;
      case "Reference Count":
        return <ReferenceCount />;
      case "Reference Downloader":
        return <ReferenceDownloadFAQ />;
      case "AppGen":
        return <AppGenFAQ />;
      case "Remove Embedded Fonts":
        return <RemoveEmbeddedFonts />;
      case "US Patent":
        return <USPatent />;
      case "US Trademark":
        return <USTrademark />;
      case "AU Patent":
        return <AUPatent />;
      case "AU Trademark":
        return <AUTrademark />;
      case "Getting Started":
        return <GettingStarted />;
      case "1449 and 892 Downloader":
        return <Downloader1449And892 />;
      case "Support & Help":
        return <TechnicalSupport />;
      case "37 CFR or 3.73(c)":
        return <CFR37 />
      case "Oath/Dec & ADS Downloader":
        return <DownloaderOathADS />
      case "Reference Extractor":
        return <RefExtractor />
      case "Patent File Wrapper Downloader":
        return <PatentFileWrapperDownloader />
      case "POA / GPOA":
        return <GPOA />
      case "Change of correspondence address (Application)":
        return <ApplicationCorrespondenceAddress />
      case "Change of correspondence address (Patent)":
        return <PatentCorrespondenceAddress />
      case "RCE Transmittal":
        return <TransmittalRCE />
      case "RCE Transmittal (EFS)":
        return <TransmittalRCE_EFS />
      case "Claims Formatter":
        return <ClaimsFormatter />;
      case "EP Patent":
        return <EPPatent />;
      case "US TM Image Download":
        return <USTrademarkImageDownload  />;
      case "Global Patent":
        return <GlobalPatent  />;
      default:
        return (
          <ComingSoon />
        );
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        bgcolor: "#f5f8fc",
        py: 2,
        height: "100%",
        flex: 1,
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      {/* Sidebar */}
      <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >

          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
              scrollbarGutter: "stable",
            }}
          >
            <HelpSidebar sidebarItems={sidebarItems(intentList) || []} tab={tab} setTab={setTab} />
          </Box>
        </Box>
      </Grid>

      {/* Content */}
      <Grid item xs={12} md={9} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
            }}
          >
            {renderFaqDoc(tab)}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FAQs;
